import { Component, OnInit } from '@angular/core';
import { id } from '@swimlane/ngx-charts';
import { OrderList } from 'src/app/app.models';
import { AppService } from 'src/app/app.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {
  public id = 0;
  public orderItem: any = [];

  constructor(public appService: AppService, private activatedRoute: ActivatedRoute, public snackBar: MatSnackBar) { }

  ngOnInit() {

    this.getAllOrders();
    this.activatedRoute.params.subscribe(params => {
      if (params['id']) {
        this.id = params['id'];
        this.orderCancel(this.id);
      }
    });

  }

  public getAllOrders() {
    this.appService.getOrdersForUser("api/Order/GetOrderByUserId/").subscribe(data => {
      this.orderItem = data;
    });
  }

  public orderCancel(id) {
    this.appService.getOrderCancel(`api/Order/OrderCancel/${id}`, {}).subscribe(data => {
      this.snackBar.open('Order cancelled successfully.', '×', { panelClass: 'success', verticalPosition: 'top', duration: 3000 });
      this.getAllOrders();
    },
      (error) => {
        this.snackBar.open('Something went wrong.', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });

      });
  }

}
